import React from 'react'

import { MarketSegmentFilter } from '@/components/ListFilter'

import { ScheduledCommunicationScheduledDateFilter } from './Filters/ScheduledCommunicationScheduledDateFilter'
import { ScheduledCommunicationStatusFilter } from './Filters/ScheduledCommunicationStatusFilter'

type Props = {}

export const ScheduledCommunicationsFilterBar = ({}: Props) => {
  return (
    <div className="flex flex-col items-center pb-6 md:flex-row-reverse md:justify-end lg:flex-row">
      <div className="mr-2 flex w-full flex-row items-center gap-2 md:mr-4 md:justify-end md:gap-3 lg:flex-wrap">
        <ScheduledCommunicationScheduledDateFilter />
        <ScheduledCommunicationStatusFilter />
        <MarketSegmentFilter className=" w-full md:w-auto" />
      </div>
    </div>
  )
}
